// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__jrYR6","left":"footer_left__I-TOG","right":"footer_right__Q2Yd9","content":"footer_content__EBRcB"};